// React Imports
import * as React from "react";

// Third party imports
import { I18n } from "react-redux-i18n";

// Component imports
import { FieldsManagement } from "./components/fields-management";

// Type imports
import { IInputComponent } from "@modules/fhq-design-tool/types/input-component";
import { FolderPrimaryListDto } from "@common/dto/folder/primary-list-dto";
import { FolderContext } from "@common/dto/folder/context";
import { FieldType } from "@common/dto/field/type";
import { FieldListDto } from "@common/dto/field/list-dto";
import { GetModuleFoldersParams } from "@common/actions/folders";
import { GetFolderFieldsParams } from "@common/actions/formats";
import { PedigreeSettingSelectedField } from "./components/fields-management/fields-management.types";
import { QuestionnaireManagementErrors } from "@modules/fhq-design-tool/controllers/questionnaire-validation";

// Style imports
import "./pedigree-setting.styles.scss";

// Other imports

export type PedigreeSettingOnChangeValue = {
  field: {
    id: string | number;
    system: boolean;
    name: string;
    context: FolderContext;
    type: FieldType;
  };
};

export type PedigreeSettingProps = IInputComponent<
{
  [key: string]: any;
},
  Array<PedigreeSettingSelectedField>
> & {
  clearable?: boolean;
  labelWidth?: number | string;
  label: string;
  placeholder?: string | number;
  getFolders: (
    params?: GetModuleFoldersParams
  ) => Promise<Array<FolderPrimaryListDto>>;
  getFields: (params: GetFolderFieldsParams) => Promise<Array<FieldListDto>>;
  errors?: QuestionnaireManagementErrors;
};

export const PedigreeSetting: React.FC<PedigreeSettingProps> = (props) => {
  const { label, onChange, value, getFields, getFolders,errors } = props;

  const [selectorOpened, setSelectorOpenedState] = React.useState(false);

  const closeSelector = React.useCallback(() => {
    setSelectorOpenedState(!selectorOpened);
  }, []);

  const handleChange = React.useCallback(
    ({ fields }: { fields: PedigreeSettingSelectedField[] }) => {
      onChange(fields);
    },
    [onChange]
  );

  return (
    <>
      {
        <FieldsManagement
          value={value.map(
            (item: { fieldId: number; fieldName: string; delimiter: string; internalUniqId: any , field?:any, systemfield:boolean }) => {  // add dto todo
              return {
                delimiter: item.delimiter,
                fieldId: item.fieldId,
                fieldName: item.fieldName || item.fieldId,
                field: item.field || {fieldName : item.fieldId},
                systemfield:item.systemfield
              };
            }
          )}
          onClose={closeSelector}
          config={{
            modalTitle: I18n.t("Rename Pedigree on Submit"),
            addFieldsLabel: label,
            submitProps: {
              submit: handleChange,
              text: I18n.t("Save"),
            },
          }}
          getFieldsFolders={getFolders}
          getFields={getFields}
          errors={errors}
        />
      }
    </>
  );
};
